import { createFileRoute } from '@tanstack/react-router';
import { CatalogListPage } from '../../../features/catalog/CatalogListPage.js';
import { loadCatalog } from '../../../features/catalog/streams.js';

export const Route = createFileRoute('/_app/catalog/')({
  loader: ({ context: { queryClient } }) => loadCatalog(queryClient),
  component: CatalogListPage,
});
